export default __webpack_public_path__ + "static/media/Pegapal.5777c4b3.png";